import axios, { AxiosResponse, AxiosError } from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('financy_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('financy_token');
      localStorage.removeItem('financy_user');
      
      // Only redirect if not already on login page; signing in again comes
      // back here (an invitation link, a group's entry).
      if (window.location.pathname !== '/login') {
        const back = `${window.location.pathname}${window.location.search}`;
        window.location.href = `/login?next=${encodeURIComponent(back)}`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;